angular.module('olivioConfiguratorApp')
  .factory('Storage', ['$q', '$rootScope', '$resource', 'Model', 'Data', 'StepService', 'env', function ($q, $rootScope, $resource, Model, Data, StepService, env) {
    var localStorageIdentifier = 'seluxOlivioConfiguratorModel';

    /**
     * writes data to Model
     * @param data decoded data
     * @returns boolean true if data is correct, false if it was rejected
     */
    function restoreData(data) {
      if (data && Data.checkModelState(data)) {
        angular.extend(Model.model, data); // change model
        var skippedViews = Model.getSkippedViews(Model.model);
        for (var name in skippedViews) {
          var step = StepService.getStep(name);
          step.skipped = skippedViews[name];
        }
        Model.ensureValidState(); // Data.checkModelState does not ensure consistent done states and does not ensure data unset for not done steps
        StepService.configurationSteps.filter(s => s.view === 'power')[0].skipped = false;
        StepService.updateEnabled();
        console.log('restoreData done', {model: Object.assign({}, Model.model)});
        return true;
      } else {
        console.error('restoreData got invalid data');
        return false;
      }
    }

    var service = {
      saveStateToLocalStorage: function () {
        console.log('saveStateToLocalStorage', Model.model);
        if (window.sessionStorage) {
          sessionStorage[localStorageIdentifier] = service.encodeState(Model.model);
        }
      },

      /**
       * save model to server
       * @param [onSuccess] has one parameter: the token
       * @param [onError]
       */
      saveStateToServer: function (onSuccess, onError) {
        console.log('saveStateToServer',  env.configurationStorageUrl, configurationStorageResource, Model.model);
        return modelStorageResource.save(Model.model, function (response) {
          console.log('saveStateToServer success:',response.token);
          if (onSuccess) {
            onSuccess(response.token);
          }
        }, function (p) {
          console.log('saveStateToServer error:',p);
          if (onError) {
            onError();
          }
        });
      },

      /**
       * save configuration to server
       * @param [onSuccess] has one parameter: the token
       * @param [onError]
       */
      saveConfigurationToServer: function (onSuccess, onError) {
        var configuration = Model.extractConfiguration();
				console.log('saveConfigurationToServer', env.configurationStorageUrl, configurationStorageResource, configuration);
        return configurationStorageResource.save(configuration, function (response) {
          console.log('saveConfigurationToServer success:',response.token);
          if (onSuccess) {
            onSuccess(response.token);
          }
        }, function () {
          console.log('saveConfigurationToServer error:',response.token);
          if (onError) {
            onError();
          }
        });
      },

      /**
       *  Restore state from server (by given token)
       * @param [stateTokenToBeRestored] the token
       */
      restoreStateFromServer: function (stateTokenToBeRestored) {
        console.log('restoreState reading from server, wait for server (1/2)');

        var deferred = $q.defer();
        modelStorageResource.query({token: stateTokenToBeRestored}, function (data) {
          console.log('restoreState (2/2): got data from Server ', {data: Object.assign({}, data) });

          if (restoreData(data)) {
            deferred.resolve();
          } else {
            deferred.reject();
          }
        }, function () {
          console.error('restoreState reading from server, empty response (2/2)');
          deferred.reject();
        });

        return deferred.promise;
      },
      /**
       *  Restore configuration from server (by given token)
       * @param [configurationTokenToBeRestored] the token
       */
      restoreConfigurationFromServer: function (configurationTokenToBeRestored) {
        console.log('restoreConfiguration reading from server, wait for server (1/2)');

        var deferred = $q.defer();
        configurationStorageResource.query({token: configurationTokenToBeRestored}, function (data) {
          console.log('restoreConfiguration (2/2): got data from Server ', {data: Object.assign({}, data) });

          if (restoreData(data)) {
            deferred.resolve();
          } else {
            deferred.reject();
          }
        }, function () {
          console.error('restoreConfiguration reading from server, empty response (2/2)');
          deferred.reject();
        });

        return deferred.promise;
      },

      /** Restore state from localStorage */
      restoreStateFromLocalStorage: function () {
        if (window.sessionStorage) {
          console.log('restoreState reading from localStorage ...');

          var localStorageExists = !!sessionStorage[localStorageIdentifier];
          if (localStorageExists) {
            var data = service.decodeState(sessionStorage[localStorageIdentifier]);

            if (!restoreData(data)) {
              sessionStorage[localStorageIdentifier] = null;
            }
          } else {
            console.log('... nothing to restore');
          }
        } else {
          console.error('... restoreState failed. no localStorage support.');
        }
      },

      encodeState: function (o) {
        return LZString.compressToBase64(angular.toJson(o));
      },

      decodeState: function (s) {
        try {
          return angular.fromJson(LZString.decompressFromBase64(s));
        } catch (e) {
          console.log('decodeState failed.');
        }
        return null;
      }
    };

    var modelStorageResource = $resource(env.modelStorageUrl, {}, {
      query: {method: 'GET', transformResponse: service.decodeState, isArray: false},
      save: {method: 'POST', transformRequest: service.encodeState}
    });

    var configurationStorageResource = $resource(env.configurationStorageUrl, {}, {
      query: {method: 'GET', transformResponse: service.decodeState, isArray: false},
      save: {method: 'POST', transformRequest: service.encodeState}
    });

    $rootScope.$on('$routeChangeStart', function (event, current, previous) {
      // save state
      service.saveStateToLocalStorage();
    });

    return service;
  }]);
